import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Column 1: Brand & Description */}
          <div className="footer-column footer-brand-col">
            <div className="footer-logos-combined">
              <div className="logo footer-logo">
                <img src="/logo-brain-event-white.webp" alt="Brain Event" className="logo-img" />
              </div>
              <span className="logo-separator">×</span>
              <div className="logo footer-logo-neuros">
                <img src="/assets/logo-on-black.webp" alt="Neuros" className="logo-img-neuros" />
              </div>
            </div>
            <p className="footer-description">
              Brain Event este locul unde știința întâlnește oportunitatea. Construit pentru persoane care doresc conexiuni reale, idei proaspete și momente care conduc la acțiune.
            </p>
            <p className="footer-copyright">© Brain Event 2026. Toate drepturile rezervate</p>
          </div>

          {/* Column 2: Important Links */}
          <div className="footer-column footer-links-col">
            <h3 className="footer-column-title">Link-uri importante</h3>
            <ul className="footer-links">
              <li><a href="/termeni-si-conditii">Termeni și Condiții</a></li>
              <li><a href="/politica-de-confidentialitate">Politica de Confidențialitate</a></li>
              <li><a href="/politica-cookies">Politica Cookies</a></li>
              <li><a href="/gdpr">GDPR</a></li>
              <li><a href="https://anpc.ro/ce-este-sal/?ref=footer_3_5" target="_blank" rel="noopener noreferrer">ANPC - SAL</a></li>
              <li><a href="https://anpc.ro/?ref=footer_3_6" target="_blank" rel="noopener noreferrer">ANPC</a></li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="footer-column footer-contact-col">
            <h3 className="footer-column-title">Contact</h3>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <a href="mailto:contact@brain-event.com">contact@brain-event.com</a>
              </li>
              <li className="footer-contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <a href="tel:+40767978707">+40 767 978 707</a>
              </li>
              <li className="footer-contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>București, România</span>
              </li>
            </ul>
            
            {/* Social Media Icons - Hidden for now */}
            {/* <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" fill="none" stroke="#06B6D4" strokeWidth="2"/>
                  <path d="M17.5 6.5h.01" stroke="#06B6D4" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;


